import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { routing } from './app.routing';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LoginService } from './login/login.service';
import { DispatcherHomeService } from './dispatcher/dispatcherhome/dispatcherhome.service';
import { DispatcherComponent } from './dispatcher/dispatcher.component';
import { DispatcherService } from './dispatcher/dispatcher.service';
import { DispatcherHomeComponent } from './dispatcher/dispatcherhome/dispatcherhome.component';
import { TasksComponent } from './dispatcher/tasks/tasks.component';
import { TasksService } from './dispatcher/tasks/tasks.service';
import { AccountComponent } from './dispatcher/account/account.component';
import { AccountService } from './dispatcher/account/account.service';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FileUploadModule } from 'ng2-file-upload';
import { ImageUploadModule } from 'angular2-image-upload';
import { Configuration } from './app.configuration';
import { LanguageService } from './language.service';
import { WalletComponent } from './dispatcher/wallet/wallet.component';
import { ConfigService } from './config.service';

import { SocialLoginModule, AuthServiceConfig } from 'angularx-social-login';
import {
  GoogleLoginProvider,
  FacebookLoginProvider
} from 'angularx-social-login';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { StopPropagationDirective } from './Utils/Directives/stop-propagation.directive';
import { OnlineStatusComponent } from './Utils/online-status/online-status.component';
import { LanguageInterceptor } from './Utils/Interceptor/language.interceptor';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { CardModule } from 'ngx-card/ngx-card';

const config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(
      '722911924807-fej8c1lbatoos1948tqbiodqavhucq7n.apps.googleusercontent.com'
    )
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider('496438897897054')
  }
]);

export function provideConfig() {
  return config;
}

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    routing,
    BrowserAnimationsModule,
    FileUploadModule,
    SocialLoginModule,
    InfiniteScrollModule,
    CardModule,
    ImageUploadModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    AppComponent,
    AccountComponent,
    LoginComponent,
    DispatcherComponent,
    DispatcherHomeComponent,
    TasksComponent,
    WalletComponent,
    StopPropagationDirective,
    OnlineStatusComponent
  ],
  providers: [
    LoginService,
    DispatcherService,
    DispatcherHomeService,
    AccountService,
    Configuration,
    LanguageService,
    TasksService,
    ConfigService,
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
